import { render, staticRenderFns } from "./extraData.vue?vue&type=template&id=4ab4ce3e&scoped=true&"
import script from "./extraData.vue?vue&type=script&lang=js&"
export * from "./extraData.vue?vue&type=script&lang=js&"
import style0 from "./extraData.vue?vue&type=style&index=0&id=4ab4ce3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab4ce3e",
  null
  
)

export default component.exports